import { Directive, Input, HostBinding, HostListener } from "@angular/core";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";

@Directive({
  selector: "[ClickColor]"
})
export class ClickColorDirective {
  private toggle: boolean = false;
  @Input() color: string = "#72f8ad";

  constructor(private doms: DomSanitizer) {}

  @HostBinding("style") get myStyle(): SafeStyle {
    let style: string = this.toggle 
      ? `background: ${this.color} ; padding:5px ;  border-radius: 4px `
      : "";
    return this.doms.bypassSecurityTrustStyle(style);
  }

  @HostListener("click") onClick() {
    this.toggle = !this.toggle;
  }
}
